<script setup>
  import { ref } from "vue";
  import ErrorAlert from "@/components/Alerts/ErrorAlert.vue";
  import PageContainer from "@/components/Atoms/PageContainer.vue";
  import { RosterService } from "@/services/RosterService";
  import { useAuthStore } from "@/stores/AuthStore";
  import router from "@/routes/vueRouter";

  // Check-in template assignment was removed from the invite flow:
  // template assignment rides training programs now (ADR 0001).

  const authStore = useAuthStore();
  const errors = ref([]);

  const submitHandler = async (data) => {
    errors.value = [];
    try {
      await RosterService.inviteClient({
        accountPrefixId: authStore.currentUser.account.prefix_id,
        trainerId: authStore.currentUser.id,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
      });
      router.push({ name: "ActiveClientsPage" });
    } catch (err) {
      const message = err.response?.data?.error || "Failed to send invitation.";
      errors.value.push(message);
    }
  };
</script>

<template>
  <PageContainer>
    <FormKit
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <FormKit
        type="email"
        label="Email"
        validation="required"
        name="email"
      />
      <div class="grid md:grid-cols-2 gap-4 grid-cols-1">
        <FormKit
          type="text"
          label="First Name"
          validation="required"
          name="firstName"
        />
        <FormKit
          type="text"
          label="Last Name"
          validation="required"
          name="lastName"
        />
      </div>
      <ErrorAlert
        v-if="errors.length > 0"
        :errors="errors"
      />
      <FormKit
        type="submit"
        label="Invite"
      />
    </FormKit>
  </PageContainer>
</template>
